import { default as Iconn } from "@folksam/ui/components/icons/IconBulletMd";

import { Box } from "../cores";

const IconFargBetyg = ({ value }: { value: string }) => {
  const convertedValue = parseInt(value);
  return (
    <Box
      as="span"
      sx={{
        color:
          convertedValue <= 1
            ? "secondaryScale.6"
            : convertedValue <= 2
            ? "quanternaryScale.5"
            : "tertiaryScale.6",
      }}
    >
      <Iconn />
    </Box>
  );
};

export default IconFargBetyg;
